import { useClipboard } from '@vueuse/core'
import { createTooltip, destroyTooltip } from 'floating-vue'

import YbClipboard from '@/components/YbClipboard.vue'
import { componentModal } from '@/utils/misc/modal'

export async function copyToClipboard(el: Element, text: string, label: string = '') {
  if (!text) {
    return
  }
  text = String(text)
  const { copy } = useClipboard()

  try {
    // Copy to the clipboard
    await copy(text)

    // Notify the user.
    const content = label ? `Copied ${label}!` : 'Copied!'
    const tooltip = createTooltip(el, {
      triggers: [],
      content,
    }, {})
    tooltip.show()
    setTimeout(() => {
      tooltip.hide()
      setTimeout(() => {
        destroyTooltip(el)
      }, 500)
    }, 2 * 1000)
  } catch (e) {
    console.error(e)
    componentModal('Clipboard Access', 'Close', YbClipboard, { text, label }, undefined, { outerContentClass: 'yb-view-content yb-view'})
  }
}
